<template>
    <!--- Section type Global --->
    <section
        id="appBody"
        class="section section_type_global is_new-design"
        :class="[headerClasses, getTheme]"
        @click="onClick"
    >
        <!-- header -->
        <SectionHeader v-show="showHeader"/>
        <!--- Section type Aside --->
        <SectionAside v-show="!isGuest && hasAside" v-if="$version != 'geotab'"/>
        <!--- Section type Main-side --->
        <SectionMainside :class="sectionGlobalClass.class">
            <template v-slot:head v-if="$version == 'geotab'">
                <SectionAside v-show="!isGuest && hasAside" v-if="!!routeMeta?.list"/>
                <template v-else-if="loadedComponents['MdPage']">
                    <teleport to="#routeTabs">
                        <SectionAside v-show="!isGuest && hasAside"/>
                    </teleport>
                </template>
            </template>
        </SectionMainside>
        <!--- -- --->
    </section>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from "vuex";
import SectionAside from '@/components/SectionAside.vue'
import SectionMainside from '@/components/SectionMainside.vue'
import SectionHeader from '@/components/SectionHeader.vue'
import {computed} from "vue";
import {useToast} from "vue-toastification";
import {treeToFlat} from "@progress/kendo-vue-treelist";
import {diffObjects} from "@/lib/lib";
import axios from "axios";
// import {diffObjects} from "@/lib/lib";
// import PageLoading from "@/views/PageLoading.vue";

export default {
    name: 'sectionGlobal',
    components: {
        // PageLoading,
        SectionAside,
        SectionMainside,
        SectionHeader,
    },
    data() {
        return {
            ready: false,
            pathname: null,
            urlSearchParams: null,
            interval: null,
            sectionGlobalClass: {},
            toast: useToast(),
            loadedComponents: {}
        }
    },
    provide() {
        return {
            sectionGlobalClass: computed(() => this.sectionGlobalClass),
            appUserReloadValue: computed(() => this.appUserReloadValue),
            loadedComponents: computed(() => this.loadedComponents),
        }
    },
    computed: {
        ...mapGetters([
            "getAppUserId",
            "getAppUser",
            "isGuest",
            "isLoginValid",
            "getApiToken",
            "getApiTokenExpiresIn",
            "getUserStorageKey",
            "getTheme",
        ]),
        hasAside() {
            return !(this.routeMeta.showAsideMenu === false)
        },
        headerClasses() {
            return !this.isGuest && [this.$product, (this.$product+'-'+this.$site), (this.$product+'-'+this.$site)+'-'+this.$version]
        },
        showHeader(){
            return !this.isGuest && (this.$consts.app.$isPrometheus && !this.$version)
        },
        appUserReloadValue(){
            return this.getAppUserId ? /*JSON.stringify*/({
                units_of_measure: this.getAppUser?.units_of_measure,
                time_zone: this.getAppUser?.time_zone,
                lang: this.getAppUser?.lang
            }) : null
        },
    },
    watch: {
        getApiToken: {
            handler: function (newVl, oldVl) {
                if(!(newVl > ' ') && (oldVl > ' ')){
                    this.clearAllData()
                    if(!this.routeMeta.isGuest) {
                        this.$router.push({name: 'Login'})
                    }
                } /*else
                if(newVl > ' ' && !(oldVl > ' ') && this.routeName === 'Login'){
                    this.$router.push('/')
                }*/
            }
        },
        getApiTokenExpiresIn: {
            handler: function (t) {
                if (t <= 0) {
                    console.warn('this token expired !!!', t)
                } else
                if (t < 600) {
                    console.warn('this token will expire soon!!!', t)
                    this.refreshTokens()
                        .catch((error) => {
                            if (this.$isDevelopment) console.error(error);
                        })
                }
            }
        },
        getAppUser:{
            handler: function (user) {
                if(this.$site === 'admin' && user.id && !user.is_admin) {
                    this.onLogout()
                }
                if(user.id && !this.isLoginValid && this.routeName !== 'ChangeEmail' && !this.routeMeta.isGuest) {
                    this.$router.push({name: 'ChangeEmail'})
                }
            }
        },
        appUserReloadValue:{
            handler: function (nVal, oVal) {
                let diff = diffObjects(oVal, nVal)
                if(!!nVal && !!oVal && !!diff) {
                    this.reloadAppProps()
                }
            },
            deep: true
        }
    },
    created() {
        let routes =
            treeToFlat(this.$router.options.routes[0].children, 'name', 'children')
                .map(route => {
                    return {
                        name: route.name,
                        path: route.path,
                        meta: route.meta,
                    }
                })
        this.setRoutes(routes);

        if(this.$isAdminSite || (this.$isPrometheus && this.$isPortalSite)) {
            let entriScript = document.createElement('script')
            entriScript.src = 'https://cdn.goentri.com/entri.js'
            entriScript.type = 'text/javascript'
            document.body.appendChild(entriScript)
        }

        let uri = window.location.search.substring(1);
        this.urlSearchParams = new URLSearchParams(uri);
        this.pathname = window.location.pathname

        this.calcWidth()
        this.fetchTimezones();
        window.addEventListener('resize', this.calcWidth)
        this.setFavicon()
        this.setTitle()
    },
    mounted() {
        //locale
        let lang = localStorage.getItem(process.env.VUE_APP_PRODUCT+'.lang')
        lang = this.$consts.langs.map(l => l.id).includes(lang)? lang : 'en'
        this.$i18n.locale = lang
        let theme = localStorage.getItem(process.env.VUE_APP_PRODUCT + '.theme')
        this.setTheme((this.$consts.app.$isIntuit ? null : theme) || this.$consts.themes.white)

        //tokens
        let token = this.urlSearchParams.get("access-token");
        if (this.pathname === "/login" && token) {
            //if(this.$isDevelopment) console.log("access-token", token)
            this.loginByToken(token)
                .then(() => {
                    this.fetchAppProps()
                })
                .catch((error) => {
                    if(this.$isDevelopment) console.error(error);
                    if (error.status === 401) {
                        this.updateTokens({})
                        this.$router.push({name: 'Login'})
                    }
                })
        } else {
            token = localStorage.getItem(process.env.VUE_APP_PRODUCT + '.authtoken')
            // this.$cookies.get('authtoken')
            if(token) {
                this.setToken(token)
                this.refreshTokens()
                    .then(() => {
                        this.fetchAppProps()
                    })
                    .catch((error) => {
                        if (this.$isDevelopment) console.error(error);
                        if (error.status === 401) {
                            this.updateTokens({})
                            this.$router.push({name: 'Login'})
                        }
                    })
            }
        }
        // if (!this.isGuest) {
        //     this.fetchAppProps()
        // }

        window.addEventListener('storage', this.onStorageAuthChange)

        this.interval = setInterval(() => {
            let t = Math.round(Date.now() / 1000)
            this.incrementUnitsLmsgTimeAgo()
            this.fetchByTimer({time: t, page: this.mainRouteName || this.routeName})
            this.updateDateNow(t)
        }, 1000)
    },
    beforeUnmount() {
        window.removeEventListener('storage', this.onStorageAuthChange)
        if(this.interval) {
            clearInterval(this.interval)
            this.interval = null
        }
    },
    methods: {
        ...mapMutations([
            "setShowFilterDropdownMenu",
            "setShowFilterXtypesDropdownMenu",
            "setFilterGeoitemDropdownMenu",
            "setShowUserMenu",
            "clearUnits",
            "setShortWidth",
            "setWindowWidth",
            "setRoutes",
            "setTheme",
            "setToken",
            "updateTokens",
            "updateDateNow",
            "setTimeZones",
        ]),
        ...mapActions([
            "loginByToken",
            "refreshTokens",
            "fetchAppProps",
            "reloadAppProps",
            "clearAllData",
            "incrementUnitsLmsgTimeAgo",
            "fetchByTimer",
            "logout",
        ]),
        onLogout() {
            this.toast.error(this.$t('Access denied'))
            this.logout()
        },
        calcWidth(){
            this.setShortWidth(window.innerWidth < this.$consts.shortWidth)
            this.setWindowWidth(window.innerWidth)
        },
        onClick(e){
            //ToDo fix (use click-outside)
            // https://unreal-stuff.ru/articles/js/vue/vue-js-solutions/vue3-click-outside/
            // https://stackoverflow.com/questions/36170425/detect-click-outside-element
            //if(this.$isDevelopment) console.warn('onClick', e.target)
            // Close the dropdown if the user clicks outside of it
            let onDropdownMenu = e.target.matches('.filter-search__dropdown-menu *')
                || e.target.matches('.button_dropdown-menu') || e.target.matches('.button_dropdown-menu *')
            if(!onDropdownMenu) {
                this.setShowFilterDropdownMenu(false)
                this.setShowFilterXtypesDropdownMenu(false)
                this.setFilterGeoitemDropdownMenu(false)
            }
            this.setShowUserMenu(false)
        },
        isAuthenticated(){
            let token = localStorage.getItem(process.env.VUE_APP_PRODUCT+'.authtoken')
            return (token && token>'')
        },
        onStorageAuthChange(event){
            if(event.key !== process.env.VUE_APP_PRODUCT+'.authtoken') return
            if(!this.isGuest) return
            if(!this.$consts.authGuestRoutes.includes(this.$route.name)) return
            let token = event.newValue
            if(!(token > '')) return
            this.setToken(token)
            this.refreshTokens()
                .then(() => {
                    this.fetchAppProps()
                    this.$router.push(this.$consts.default_route)
                })
                .catch((error) => {
                    if(this.$isDevelopment) console.error(error);
                })
        },
        setFavicon(){
            document
                .querySelector('link[rel="icon"]')
                .setAttribute('href', this.$config.customize.baseURL+'/site-customize/favicon?t='+(Date.now()))
        },
        setTitle(){
            let title = process.env.VUE_APP_TITLE
            fetch( this.$config.customize.baseURL+'/site-customize/site_name?t='+(Date.now()))
                .then((response) => {
                    //console.log(response)
                    if(response.ok){
                        return response.json();
                    } else {
                        console.warn(response.status, response)
                    }
                })
                .then((data) => {
                    if (data && data.site_name > '') {
                        title = data.site_name
                    }
                })
                .catch(e => {
                    console.error('There has been a problem with your fetch operation: ' + e.message);
                })
                .finally(() => {
                    document.querySelector('title').innerHTML = title
                })
            ;
        },
        fetchTimezones() {
            let path = '/../config/time-zones.json';
            let url = this.$config.api.baseURL + path
            axios.get(url)
                .then((response) => {
                    if(response.status < 400 && !response?.error && !response?.errors) {
                        if (response.status < 400 && !response.data.error) {
                            this.setTimeZones(response?.data)
                        }
                    }
                })
        },
    },
}
</script>

<style lang="scss">
@import "~@/scss/main.scss";
.section_type_global {
    display: flex;
    /* eslint-env node */
    height: 100dvh;

    transition: all var(--transition-duration-md) ease-in-out;

    .section_type_main-side,
    .section_type_basic,
    .section_type_content {
        height: 100%;
    }
    &.section_has-aside {
        grid-template-columns: auto 1fr;
    }
}
.prometheus {
    $headerHeight: 64px;

    display: grid;
    grid-template-areas:
    "header header"
    "aside main-side";
    grid-template-rows: $headerHeight 1fr;
    grid-template-columns: 70px 1fr;

    .aside-menu_wrap{
        grid-area: aside;
        height: 100%;
        grid-template-rows: 1fr auto;
    }
    .section_type_main-side{
        grid-area: main-side;
    }
}
.prometheus-portal {
    $headerHeight: 50px;
    grid-template-rows: $headerHeight 1fr;
}
.prometheus-portal-geotab {
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
    grid-template-areas:
    "main-side";

    .section {
        &.section_type_main-side {
            display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: auto 1fr;
            .aside-menu_wrap {
                grid-column: 1;
                grid-row: 1;
                min-width: 250px;
            }
            .section_type_list {
                grid-column-start: 1;
                grid-row-start: 2;
            }
            .section_type_basic {
                grid-column-start: 2;
                grid-row-start: 1;
                grid-row-end: 3;
            }
            .menu {
                .nav__list {
                    display: flex;
                }
            }
        }
        .section_type_aside {
            grid-template-rows: 1fr;
            grid-template-columns: 1fr auto;
            padding: 0 20px;
        }
        .aside__info .info__connect {
            padding: 0;
        }
        .is_new-design .nav__item {
            height: 3.5rem;
        }
    }


    .header,
    .aside-menu_wrap {
        //display: none;
    }
    @media all and (max-width: 980px) {
        .weather-control {
            display: none;
        }
    }
}

.prometheus-admin {
    grid-template-columns: 104px 1fr;
}
.section.section_type_login {
    background: url("~@/assets/img/empty1px.png");
    background-size: cover;
}

.section.section_type_form-page {
    background: url("~@/assets/img/empty1px.png");
    background-size: cover;
}
</style>
